'use strict';
//signalrService MIGRADO
angular.module('TurneroApp').component('coAtencionFilaListado', {
    bindings: {
        centroAtencionSeleccionado: '<',
        usuarioConfig: '<',
        turno: '=',
        bloquearAcciones: '<',
        ctrlAtencionPadre: '=',
        limpiarMemoria: '&',
        llamarTurno: '<',
        volverEstadoAnterior: '=',
        validarDerivadoAMi: '=',
        changeBloquearAcciones: '=',
    },
    controller: [
        'turnosService',
        'TurneroAppConstant',
        'utilsService',
        'usuariosService',
        'signalrDotNetCoreService',
        '$state',
        '$localStorage',
        '$timeout',
        function (turnosService, TurneroAppConstant, utilsService, usuariosService, signalrService, $state, $localStorage, $timeout) {
            var ctrl = this;
            ctrl.btnLlamarDisabled = true;
            ctrl.btnAtenderDisabled = true;
            ctrl.btnPerderDisabled = true;
            ctrl.atendidoPorMi = false;
            ctrl.derivadoAMi = false;
            ctrl.derivadoPorMi = false;
            ctrl.derivadoPorOtro = false;
            ctrl.timeoutLlamado = null;

            // se definen las constantes que estan en TurneroAppConstant como variables locales para poder utilizarlas en el js y el html
            ctrl.TurnosEstados = TurneroAppConstant.Estados.Turno;
            ctrl.Modalidades = TurneroAppConstant.Modalidades;
            ctrl.Derivacion = TurneroAppConstant.Derivacion;

            ctrl.$onDestroy = function () {
                if (ctrl.timeoutLlamado)
                    $timeout.cancel(ctrl.timeoutLlamado);
            }

            //cada vez que cambien los enlaces unidireccionales ("<")
            ctrl.$onChanges = function () {
                ctrl.atendidoPorMi = ctrl.turno.Id_Estado == ctrl.TurnosEstados.Atendido && ctrl.turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario;
                ctrl.derivadoPorMi = ctrl.turno.Derivado == ctrl.TurnosEstados.Atendido && ctrl.turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario;

                ctrl.derivadoAMi = ctrl.turno.Id_Estado == ctrl.TurnosEstados.Derivado;

                ctrl.derivadoPorOtro = ctrl.turno.Id_Estado == ctrl.TurnosEstados.Derivado && !ctrl.derivadoPorMi && !ctrl.derivadoAMi;

                //esto lo hago para que valide solo cuando cambia el turno o alguno de los parametros y no constantemente
                ctrl.btnLlamarDisabled = ctrl.bloquearAcciones || ctrl.validarBotonLlamar();
                ctrl.btnAtenderDisabled = ctrl.bloquearAcciones || ctrl.validarBotonAtender();
                ctrl.btnPerderDisabled = ctrl.bloquearAcciones || ctrl.validarBotonPerder();

                //creo un time out para que vuelva al estado anterior cuando pasan 4 min despues de ser llamado
                //primero lo elimino si ya existia
                if (ctrl.timeoutLlamado) {
                    $timeout.cancel(ctrl.timeoutLlamado);
                }

                if (ctrl.turno.Id_Estado == ctrl.TurnosEstados.Llamado && ctrl.turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario) {
                    ctrl.timeoutLlamado = $timeout(function () {
                        console.info('vuelve el estado');
                        ctrl.volverEstadoAnterior(ctrl.turno);
                    }, ctrl.milisegVolverAtras());
                }
            }

            ctrl.milisegVolverAtras = function () {
                var ahora = new Date();
                var llamado = new Date(ctrl.turno.Fecha_Estado);
                //4 minutos menos el tiempo transcurrido
                var fin = 240000 - (ahora - llamado);
                return fin > 0 ? fin : 0;
            }

            ctrl.validarBotonAtender = function () {
                //validaciones para saber si bloquear o no el boton atender
                if (ctrl.usuarioConfig && ctrl.usuarioConfig.Llamador_Activo != undefined && ctrl.usuarioConfig.Solo_Llamar_Proximo != undefined) {
                    //Retorno falso cuando el boton debe estar habilitado sino retorno True

                    /*Cuando el turno estaba atendido por mi*/
                    if (ctrl.atendidoPorMi) {
                        return false; // DEBE HABILITARLO
                    }

                    // Cuando este Atendido por mi, retenido por mi  o llamado por mi
                    if (((ctrl.turno.Id_Estado == ctrl.TurnosEstados.Atendido ||
                        ctrl.turno.Id_Estado == ctrl.TurnosEstados.Retenido ||
                        ctrl.turno.Id_Estado == ctrl.TurnosEstados.Llamado) &&
                        ctrl.turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario)) {
                        return false; // Habilita el boton
                    };

                    //if (ctrl.derivadoAMi) {
                    //    return false; // Habilita el boton
                    //}

                    //Cuando el Solo_Llamar_Proximo, sea false y esten en estado agendado o anunciado o derivado a mi
                    if (!ctrl.usuarioConfig.Solo_Llamar_Proximo &&
                        (ctrl.turno.Id_Estado == ctrl.TurnosEstados.Agendado ||
                            ctrl.turno.Id_Estado == ctrl.TurnosEstados.Anunciado ||
                            ctrl.derivadoAMi
                        )) {
                        return false; //lo habilita
                    };

                    //debe bloquear el boton de atender
                    return true;
                }
                //debe bloquear el boton de atender
                return true;
            }

            ctrl.validarBotonLlamar = function () {
                //validaciones para saber si bloquear o no el boton llamar
                if (ctrl.usuarioConfig && ctrl.usuarioConfig.Llamador_Activo != undefined && ctrl.usuarioConfig.Solo_Llamar_Proximo != undefined) {
                    //Retorno true cuando el boton debe estar deshabilitado sino retorno false
                    if (ctrl.turno.Id_Estado == ctrl.TurnosEstados.Atendido ||
                        !ctrl.usuarioConfig.Llamador_Activo ||
                        (ctrl.usuarioConfig.Solo_Llamar_Proximo && ctrl.turno.Id_Estado != ctrl.TurnosEstados.Retenido) ||
                        (ctrl.turno.Id_Estado == ctrl.TurnosEstados.Derivado && !ctrl.derivadoAMi) ||
                        ((ctrl.turno.Id_Estado == ctrl.TurnosEstados.Llamado || ctrl.turno.Id_Estado == ctrl.TurnosEstados.Retenido) &&
                            ctrl.turno.Id_Centro_Usuario != ctrl.usuarioConfig.Id_Centro_Usuario)) {
                        //bloqueo el boton llamar
                        return true;
                    } else
                        //No lo bloqueo.
                        return false;
                }
                //bloqueo el boton llamar
                return true;
            }

            ctrl.validarBotonPerder = function () {
                if (ctrl.turno.Id_Estado == ctrl.TurnosEstados.Llamado &&
                    ctrl.turno.Cant_Llamados >= 2 &&
                    ctrl.turno.Id_Centro_Usuario == ctrl.usuarioConfig.Id_Centro_Usuario)
                    return false;

                return true;
            }

            //Info button
            ctrl.viewInfo = function () {
                ctrl.changeBloquearAcciones(true);

                if (ctrl.turno.Id_Estado == TurneroAppConstant.Estados.Turno.Anunciado) {
                    if (!ctrl.turno.Sujeto_Ley_9131) {
                        ctrl.changeBloquearAcciones(false);

                        swal({
                            title: 'Información del turno',
                            html: '<br/><strong>Agenda: </strong><br/> ' + ctrl.turno.N_Agenda + '<br/><br/><strong>Prioridad: </strong><br/>' + ctrl.turno.N_Prioridad,
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonColor: '#308130',
                            cancelButtonColor: '#004b81',
                            confirmButtonText: "Asignar prioridad Ley 9.131",
                            cancelButtonText: "Aceptar",
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function () {
                            //Asignar prioridad
                            ctrl.togglePrioridad(false);
                        }, function (error) {
                            swal.close();
                        })
                    } else {
                        swal({
                            title: 'Información del turno',
                            html: '<br/><strong>Agenda: </strong><br/> ' + ctrl.turno.N_Agenda + '<br/><br/><strong>Prioridad: </strong><br/>Ley 9.131',
                            type: 'info',
                            showCancelButton: true,
                            confirmButtonColor: '#971b2f',
                            cancelButtonColor: '#004b81',
                            confirmButtonText: "Quitar prioridad Ley 9.131",
                            cancelButtonText: "Aceptar",
                            allowEscapeKey: false,
                            allowOutsideClick: false
                        }).then(function () {
                            //Quitar prioridad
                            ctrl.togglePrioridad(true);
                        }, function (error) {
                            swal.close();
                            ctrl.changeBloquearAcciones(false);
                        })
                    }
                }
                else if (ctrl.turno.Id_Estado == TurneroAppConstant.Estados.Turno.Agendado) {
                    ctrl.changeBloquearAcciones(false);
                }
                else {
                    ctrl.loadingViewInfo = true;

                    let msgPromise = turnosService.Get_Turnos_Mensaje({
                        'Id_Turno': ctrl.turno.Id_Turno,
                        'Id_Estado': ctrl.turno.Id_Estado
                    });

                    msgPromise.$promise.catch(function (error) {
                        ctrl.loadingViewInfo = false;
                        ctrl.changeBloquearAcciones(false);
                        utilsService.errores(error);

                        if (error.data && error.data.IsUserSessionException) {
                            ctrl.limpiarMemoria();
                        }
                    })

                    switch (ctrl.turno.Id_Estado) {
                        //dependiendo de cual sea el estado actual del turno se busca el mensaje que se debe mostrar
                        case TurneroAppConstant.Estados.Turno.Llamado:
                            msgPromise.$promise.then(function (resultado) {
                                var info = resultado.Data;

                                ctrl.loadingViewInfo = false;
                                ctrl.changeBloquearAcciones(false);
                                info.HoraReciente = ctrl.calcularDiferenciaHoraria(info.Hora);

                                swal({
                                    title: 'Información del turno',
                                    html: '<br/><strong>Llamado por: </strong><br/>' + info.Listado_Agentes.split('|').join('<br/>') + '<br/><br/><strong>Último usuario que llamo: </strong><br/>' + info.N_Persona + '(' + info.N_Usuario + ')<br/>' + info.Hora_Movimiento + ' Hrs.<br/>' + info.N_Puesto + '<br/><br/><strong>Cantidad de llamados: </strong><br/>' + info.Cant_Llamados,
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false,
                                    allowOutsideClick: false
                                });
                            });
                            break;
                        case TurneroAppConstant.Estados.Turno.Atendido:
                            msgPromise.$promise.then(function (resultado) {
                                var info = resultado.Data;

                                ctrl.loadingViewInfo = false;
                                ctrl.changeBloquearAcciones(false);
                                info.HoraReciente = ctrl.calcularDiferenciaHoraria(info.Hora);

                                swal({
                                    title: 'Información del turno',
                                    html: '<br/><strong>Atendido por: </strong><br/> ' + info.N_Persona + ' (' + info.N_Usuario + ') <br/>' + info.N_Puesto + '<br/><br/><strong>La atención comenzó a las: </strong><br/>' + info.Hora + (info.HoraReciente < 1 ? ', hace unos segundos' : ''),
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false,
                                    allowOutsideClick: false
                                });
                            })
                            break;
                        case TurneroAppConstant.Estados.Turno.Retenido:
                            msgPromise.$promise.then(function (resultado) {
                                var info = resultado.Data;

                                ctrl.loadingViewInfo = false;
                                ctrl.changeBloquearAcciones(false);
                                info.HoraReciente = ctrl.calcularDiferenciaHoraria(info.Hora);

                                swal({
                                    title: 'Información del turno',
                                    html: '<br/><strong>Retenido por: </strong><br/> ' + info.N_Persona + ' (' + info.N_Usuario + ') <br/>' + info.N_Puesto + '<br/><br/><strong>Retenido a las: </strong><br/>' + info.Hora + (info.HoraReciente < 1 ? ', hace unos segundos' : ''),
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false,
                                    allowOutsideClick: false
                                });
                            })
                            break;
                        case TurneroAppConstant.Estados.Turno.Derivado:
                            msgPromise.$promise.then(function (resultado) {
                                var info = resultado.Data;

                                ctrl.loadingViewInfo = false;
                                ctrl.changeBloquearAcciones(false);
                                info.HoraReciente = ctrl.calcularDiferenciaHoraria(info.Hora);

                                swal({
                                    title: 'Información del turno',
                                    html: '<br/><strong>Derivado a las: </strong><br/> ' + info.Hora + (info.Hora ? ', hace unos segundos' : '') + '<br/><br/><strong>Tipo: </strong><br/> Por ' + info.N_Tipo_Derivacion + '<br/><br/><strong>Origen: </strong><br/>' + info.N_Persona + ' (' + info.N_Usuario + ') <br/>' + info.N_Puesto + '<br/><br/><strong>Destino: </strong><br/>' + info.Destino,
                                    type: 'info',
                                    confirmButtonColor: '#004b81',
                                    confirmButtonText: "Aceptar",
                                    allowEscapeKey: false,
                                    allowOutsideClick: false
                                });
                            })
                            break;
                    };
                }
            };

            ctrl.calcularDiferenciaHoraria = function (time) {
                var start = moment(time, "HH:mm");
                var end = moment(moment(), "HH:mm");
                return end.diff(start, 'm');
            }

            //Llamar button
            ctrl.onLlamarTurno = function () {
                ctrl.llamarTurno(ctrl.turno, true);
            };

            //Atender button
            ctrl.atenderTurno = function () {
                //PASA UN TURNO  A ESTADO ATENDIDO
                //bloqueo botones de acciones
                ctrl.changeBloquearAcciones(true);
                //si el estado del turno no es Atendido
                if (ctrl.TurnosEstados.Atendido != ctrl.turno.Id_Estado) {
                    //Cambio el estado del turno
                    turnosService.Put_Turno_Estado({
                        'id_estado': ctrl.TurnosEstados.Atendido,
                        'id_turno': ctrl.turno.Id_Turno,
                        'hacer_commit': 1,
                        'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (resultado) {
                        //idTurnoDetalle que es el id_turno que va mostrarse
                        ctrl.ctrlAtencionPadre.Id_Turno_Detalle = ctrl.turno.Id_Turno;
                        //MOSTRAR DETALLE Y OCULTAR LA GRILLA DE CONSULTA
                        ctrl.ctrlAtencionPadre.muestraTurnoDetalle(true);
                        ctrl.changeBloquearAcciones(false);

                        //actualizo este turno
                        signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                            hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, ctrl.turno.Id_Turno).then(function () {
                                console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.turno.Id_Turno + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.turno.Id_Turno + ": " + err.toString());
                            });
                        });

                        //quito el turno del llamador
                        signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                            hub.invoke('EliminarTurno', ctrl.turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                            });
                        });

                        //seteo último turno atendido
                        signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                            hub.invoke('UltimoTurnoAtendido', ctrl.turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                console.info("Se invocó a UltimoTurnoAtendido en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a UltimoTurnoAtendido en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                            });
                        });

                        //actualiza el puesto actual
                        signalrService.startHub(TurneroAppConstant.HubNames.PUESTOS).then(function (hub) {
                            hub.invoke('TraerPuesto', ctrl.centroAtencionSeleccionado.id, $localStorage.TurneroApp_UsuarioSesion.Puesto.id).then(function () {
                                console.info("Se invocó a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerPuesto en " + TurneroAppConstant.HubNames.PUESTOS + ": " + err.toString());
                            });
                        });
                    }).catch(function (error) {
                        if (error.data && error.data.IsUserSessionException) {
                            utilsService.errores(error, refresh);
                        } else {
                            utilsService.errores(error);
                        }
                        ctrl.limpiarMemoria();
                    });
                } else {
                    //Si el turno estaba en estado atendido, entonces no genera el movimiento y muestra el detalle.
                    ctrl.ctrlAtencionPadre.Id_Turno_Detalle = ctrl.turno.Id_Turno;
                    //MOSTRAR DETALLE Y OCULTAR LA GRILLA DE CONSULTA
                    ctrl.ctrlAtencionPadre.muestraTurnoDetalle(true);
                }
            };

            //Perder button
            ctrl.perderTurno = function () {
                //PASA UN TURNO  A ESTADO PERDIDO
                //bloqueo botones de acciones
                ctrl.changeBloquearAcciones(true);
                //validar que la sesion siga vigente

                let msgPromise = turnosService.Get_Turnos_Mensaje({
                    'Id_Turno': ctrl.turno.Id_Turno,
                    'Id_Estado': ctrl.turno.Id_Estado
                });

                msgPromise.$promise.catch(function (error) {
                    ctrl.loadingViewInfo = false;
                    ctrl.changeBloquearAcciones(false);
                    utilsService.errores(error);

                    if (error.data && error.data.IsUserSessionException) {
                        ctrl.limpiarMemoria();
                    }
                });

                msgPromise.$promise.then(function (resultado) {
                    var info = resultado.Data;

                    /*Este Metodo setea el turno como Perdido, pero como es una accion irreversible necesita de la confirmacion del usuario.*/
                    swal({
                        title: 'Marcar turno como perdido',
                        html: '¿Confirma que desea marcar como perdido el turno ' + ctrl.turno.Id_Turno + ' a nombre de ' + ctrl.turno.N_Persona + ' ? <br/><br/>El turno ha sido llamado ' + ctrl.turno.Cant_Llamados + ' veces, a partir de las ' + info.Hora.split(":")[0] + ":" + info.Hora.split(":")[1] + ' hs. <br/><br/><span class="text-danger">Esta acción es irreversible.</span>',
                        type: 'warning',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: 'rgb(170, 170, 170)',
                        confirmButtonText: "Aceptar",
                        cancelButtonText: "Cancelar",
                    }).then(function () {
                        turnosService.Put_Turno_Estado({
                            'id_estado': ctrl.TurnosEstados.Perdido,
                            'id_turno': ctrl.turno.Id_Turno,
                            'hacer_commit': 1,
                            'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                            'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                        }).$promise.then(function (resultado) {
                            //habilita los botones
                            ctrl.changeBloquearAcciones(false);

                            //elimina el turno del llamador
                            signalrService.startHub(TurneroAppConstant.HubNames.LLAMADOR).then(function (hub) {
                                hub.invoke('EliminarTurno', ctrl.turno.Id_Turno, ctrl.centroAtencionSeleccionado.id).then(function () {
                                    console.info("Se invocó a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ".");
                                }).catch(function (err) {
                                    console.error("Falló invocación a EliminarTurno en " + TurneroAppConstant.HubNames.LLAMADOR + ": " + err.toString());
                                });
                            });

                            //actualizo ese turno
                            signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                                hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, ctrl.turno.Id_Turno).then(function () {
                                    console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.turno.Id_Turno + ".");
                                }).catch(function (err) {
                                    console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.turno.Id_Turno + ": " + err.toString());
                                });
                            });

                            swal({
                                title: 'Turno perdido',
                                html: "Se ha marcado el turno como perdido.",
                                type: 'success',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Aceptar"
                            });
                        }).catch(function (error) {
                            if (error.data && error.data.IsUserSessionException) {
                                utilsService.errores(error, refresh);
                            } else {
                                utilsService.errores(error);
                            }
                            ctrl.changeBloquearAcciones(false);
                            ctrl.limpiarMemoria();
                        })
                    }, function (error) {
                        swal.close();
                        ctrl.changeBloquearAcciones(false);
                    });
                });
            }

            //Quitar prioridad buttons
            ctrl.quitarPrioridad = function () {
                //QUITA LA PRIORIDAD
                ctrl.togglePrioridad(true);
            }

            ctrl.togglePrioridad = function (quitar) {
                let msg = null;

                //muestro mensaje según quita o asigna prioridad
                if (quitar) {
                    msg = swal({
                        title: 'Atención prioritaria',
                        html: ctrl.turno.N_Persona + ' ha solicitado atención prioritaria, conforme a la Ley Provincial Nº 9.131.<br/><br/>Si Ud. considera que la persona no encuadra en lo previsto por la Ley, presione el botón <strong>Quitar priodidad</strong>; si no, presione el botón <stong>Mantener prioridad</stong>.<br/><br/>¿Desea continuar?',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: '#004b81',
                        confirmButtonText: "Quitar prioridad",
                        cancelButtonText: "Mantener prioridad",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                } else {
                    //Asignar prioridad
                    msg = swal({
                        title: 'Atención prioritaria',
                        html: ctrl.turno.N_Persona + ' recibirá atención prioritaria, conforme a la Ley Provincial Nº 9.131.<br/><br/>¿Desea continuar?',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: 'rgb(170, 170, 170)',
                        confirmButtonText: "Si",
                        cancelButtonText: "No",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    });
                }

                msg.then(function () {
                    //cambio la prioridad
                    turnosService.Put_Turno_Prioridad_Ley({
                        'Id_Turno': ctrl.turno.Id_Turno,
                        'id_usuario_sesion': ctrl.usuarioConfig.Id_Usuario_Sesion,
                        'id_centro_atencion': parseInt(ctrl.centroAtencionSeleccionado.id)
                    }).$promise.then(function (result) {

                        //actualizo este turno
                        signalrService.startHub(TurneroAppConstant.HubNames.TURNOS).then(function (hub) {
                            hub.invoke('TraerTurnoAtencion', ctrl.centroAtencionSeleccionado.id, ctrl.turno.Id_Turno).then(function () {
                                console.info("Se invocó a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.turno.Id_Turno + ".");
                            }).catch(function (err) {
                                console.error("Falló invocación a TraerTurnoAtencion en " + TurneroAppConstant.HubNames.TURNOS + " para el turno " + ctrl.turno.Id_Turno + ": " + err.toString());
                            });
                        });

                        //muestro mensaje de confirmación según quita o no la prioridad
                        if (quitar) {
                            swal({
                                title: 'Atención prioritaria',
                                html: 'Se ha quitado la prioridad de atención para ' + ctrl.turno.N_Persona + '.',
                                type: 'success',
                                confirmButtonColor: '#004b81',
                                confirmButtonText: "Ok",
                                allowEscapeKey: false,
                                allowOutsideClick: false
                            });
                        }

                        ctrl.changeBloquearAcciones(false);
                    }, function (error) {
                        swal.close();
                        if (error.data && error.data.IsUserSessionException) {
                            utilsService.errores(error, refresh);
                            ctrl.limpiarMemoria();
                        } else {
                            utilsService.errores(error);
                        }
                        ctrl.changeBloquearAcciones(false);
                    });
                }, function (error) {
                    swal.close();
                    ctrl.changeBloquearAcciones(false);
                });
            }

            function refresh() {
                //Refrescar la pantalla
                $state.reload();
            }
        }
    ],
    template: require('./atencionFilaListado.html')
});


// WEBPACK FOOTER //
// ./app/components/atencion/atencionFilaListadoComponent.js